export const DATADOG_SITE = 'us5.datadoghq.com';
export const DATADOG_SERVICE = 'marketplace';
